"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _InfoCircleFilled = _interopRequireDefault(require("@foxui/ui-icons-svg/lib/asn/InfoCircleFilled"));
var _AntdIcon = _interopRequireDefault(require("../components/AntdIcon"));
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var InfoCircleFilled = function InfoCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _extends2.default)({}, props, {
    ref: ref,
    icon: _InfoCircleFilled.default
  }));
};

/**![info-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMyAxMmExMSAxMSAwIDExLTIyIDAgMTEgMTEgMCAwMTIyIDB6bS0xMiA0YTEgMSAwIDEwMiAwdi00YTEgMSAwIDEwLTIgMHY0em0xLTdhMSAxIDAgMTAwLTJoLS4wMWExIDEgMCAxMDAgMkgxMnoiIGZpbGwtcnVsZT0iZXZlbm9kZCIgLz48L3N2Zz4=) */
var RefIcon = /*#__PURE__*/React.forwardRef(InfoCircleFilled);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'InfoCircleFilled';
}
var _default = exports.default = RefIcon;